(function($) {
    $(document).ready(function() {
        let slider = $('#slider-dsr-fishing-holes').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            //prevArrow: '<img class="a-left control-c prev slick-prev" src="/wp-content/uploads/2021/06/arrows-left.png">',
            //nextArrow: '<img class="a-right control-c next slick-next" src="/wp-content/uploads/2021/06/arrows-right.png">',
            responsive: [{
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,

                }
            }]
        });
        let fishingHoles = $('#dsr-fishing-holes')[0];
        $('g[id^=poi-]').click(function() {
            let id = $(this).attr('id');
            let parts = id.split('-');
            if (parts.length !== 2) return;

            let number = parts[1];
            if (number === 'all') return;

            slider.slick('slickGoTo', number - 1);

            fishingHoles.scrollIntoView();
        });
    });
})(jQuery);